import React from "react";
import { useMobileMenu } from "../hooks/useMobileMenu";
import { getDefaultMobileMenuItems } from "../data/mobileMenuItems";
import type { MobileNavBarProps } from "../types/mobileNavigation";
import MobileNavBarHeader from "./MobileNavBarHeader";
import MobileMenuDrawer from "./MobileMenuDrawer";

const NavBarContentMobile: React.FC<MobileNavBarProps> = ({
  menuItems = [],
  logoProps,
  contactAction,
  contactText = "Entrer Dans l'App",
}) => {
  const {
    isMenuOpen,
    activeSubmenu,
    containerRef,
    handleMenuToggle,
    handleSubmenuToggle,
    setIsMenuOpen,
  } = useMobileMenu();

  const currentMenuItems = menuItems.length > 0 ? menuItems : getDefaultMobileMenuItems();

  return (
    <div
      ref={containerRef}
      className="relative flex h-full w-full max-w-[1440px] flex-col items-center justify-center laptop:hidden"
    >
      <MobileNavBarHeader
        logoProps={logoProps}
        isMenuOpen={isMenuOpen}
        onMenuToggle={handleMenuToggle}
      />

      <MobileMenuDrawer
        isMenuOpen={isMenuOpen}
        activeSubmenu={activeSubmenu}
        menuItems={currentMenuItems}
        logoProps={logoProps}
        onClose={() => setIsMenuOpen(false)}
        onSubmenuToggle={handleSubmenuToggle}
        contactAction={contactAction}
        contactText={contactText}
      />
    </div>
  );
};

export default NavBarContentMobile;
